import React from "react";
import { Spinner } from "react-bootstrap";
export const Loading = (): JSX.Element => {
    return (
        <div style={{ position : "absolute", textAlign : "center", top : "50%", left : "50%", transform : "translate(-50%,-50%)" }}>
            <Spinner animation="border" role="status">
                <span className="visually-hidden" style={{ display: "none" }}>Loading...</span>
            </Spinner>
        </div>
    );
}; 